import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@gasbuddy/react-components';
import AddressPropType from '../../prop-types/address';
import ShippingAddressSummary from '../ShippingAddressSummary/ShippingAddressSummary';
import isValidAddress from '../../../lib/utils/isValidAddress';

export default function CustomerDetailsSummary({
  firstName,
  lastName,
  address,
}) {
  const hasAllInfo = !!firstName && !!lastName && isValidAddress(address);

  // NOTE: The original mockup described to show date of birth and household income as well
  // However, we do not keep that information in wallet for security reasons, hence showing only insensitive info here
  if (hasAllInfo) {
    return (
      <Text as="p">
        {firstName} {lastName}
        <ShippingAddressSummary address={address} />
      </Text>
    );
  }

  return null;
}

CustomerDetailsSummary.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  address: AddressPropType,
};

CustomerDetailsSummary.defaultProps = {
  firstName: undefined,
  lastName: undefined,
  address: undefined,
};
